<template>
<div>
  <field-label>Scraping Example</field-label>
  <p class="has-text-grey help mb-1">An example of how the payload will be used by the scraper.</p>
  <div class="box">
    <div v-html="exampleCode"></div>
  </div>

  <div class="box" v-if="testResult">
    <div class="is-flex justify-between">
      <p class="title is-5">Test Result</p>
      <action-button class="is-danger is-small is-rounded" @click="testResult = null">
        <icon icon="times"/>
      </action-button>
    </div>
    <div class="code-string" v-html="testResult"></div>
  </div>
  <div class="has-text-right">
    <action-button
      class="is-small"
      v-if="this.builder.scraper_payload"
      :working="testingScraper"
      @click="testScraper">
      Test Scraper
    </action-button>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import Scraper from '@/store/models/Scraper'
import { testEnvironmentScraper } from '@/api/super'

export default {

  props: {
    scraper: {
      type: Object,
      default: () => (new Scraper())
    }
  },

  data: () => ({
    testingScraper: false,
    testResult: null
  }),

  methods: {
    testScraper() {
      this.testingScraper = true
      testEnvironmentScraper({
        payload: this.builder.scraper_payload
      }, ({data}) => {
        this.testResult = data.result
        this.testingScraper = false
        if(!data.result) this.$toast.error('Scraping of Attribute was unsuccessful')
      }, error => this.testingScraper = false)
    }
  },
  
  computed: {
    ...mapGetters('scraperBuilder', [
      'builder'
    ]),
    exampleCode() {
      return this.scraper.handler_example.replace(
        '$payload', 
        `<span class="code-string">'${this.builder.scraper_payload}'</span>`
      )
    }
  }

}
</script>